import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { ParkedCartFilterPage } from 'src/app/modals/parked-cart-filter/parked-cart-filter.page';

const routes: Routes = [
    {
        path: '',
        component: ParkedCartFilterPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [ParkedCartFilterPage]
})

export class ParkedCartFilterPageModule { }
